$( document ).ready(function() {

  // This is required for the out of stock app to work on the first selected variant.
  var currentVarID = $('#id').val();

  const urlParams = new URLSearchParams(window.location.search);
  let savedParams = '';
  for(const entry of urlParams.entries()) {
    if(entry[0] != 'variant'){
      savedParams = `${savedParams}&${entry[0]}=${entry[1]}`;
    }
  }
  window.history.pushState( {} , '', '?variant='+currentVarID+savedParams );


  $('.product-form__input.set-width label').on('click', function() {
    let testFirstOption = $(this).data('value');
    var selectedTestLabels = document.querySelectorAll('.set-size label');
    for (var i = 0; i < selectedTestLabels.length; i++) {
      var nameTestItem = $(selectedTestLabels[i]).data('value');
      var testScenario = nameTestItem + ' / ' + testFirstOption;
      var testCounter = 0;
      $('#ProductSelect-product-template > option').each(function() {
        var thisOptName = $(this).text().replace(/^\s+|\s+$/g, '');
        if(thisOptName.indexOf(testScenario) > -1){
          testCounter++;
        }
      });
      if(testCounter <= 0){
        $(selectedTestLabels[i]).hide();
      } else {
        $(selectedTestLabels[i]).show();
      }
    }
  });
    
  // VARIANT SELECTOR
  $('.product-form__input label').on('click', function() {
    // add variant to url
    if ($(this).data('handle')) return window.location.assign(`/products/${ $(this).data('handle') }`);
    // on click make sure labels have selected
    $(this).parent().find('label').removeClass('selected');
    $(this).addClass('selected');
    var optname = '';
    var selectedLabels = document.querySelectorAll('.product-form__input label.selected');
    for (var i = 0; i < selectedLabels.length; i++) {
      var nameItem = $(selectedLabels[i]).data('value');
      if(i == 0){
        optname += nameItem
      } else {
        optname += ' / ' + nameItem;
      }
    }
    optname.replace(/^\s+|\s+$/g, '');
    var varid ='';
    var varinv ='';
    // Cycle through each hidden option and check the currently selected labels agaisnt known variants. Get the id from that.
    $('#ProductSelect-product-template > option').each(function() {
      var thisOptName = $(this).text().replace(/^\s+|\s+$/g, '');
      if(thisOptName == optname){
        varid = $(this).val();
        varinv = $(this).data('inv');
        $('#ProductSelect-product-template > option').removeAttr('selected');
        $(this).attr('selected','selected');
        window.history.pushState( {} , '', '?variant='+varid+savedParams ); // change url param but saves the savedParms set up above.
        $('input[name="id"]').val(varid);
      }
    });
    // First test if the varid exists. If not, it means the option combination doesnt exist in shopify.
    if(varid == '' ){
      let cuteOptName = ' Size ' + $(selectedLabels[1]).data('value') + ' ' + $(selectedLabels[2]).data('value');
      $('.variant-doesnt-exist').html('Sorry. We do not have this product in '+ cuteOptName);
      //shut down buying
      $('.btn-product-add-to-cart').attr('disabled', 'true');
      $('.quantity__button').attr('disabled', 'true');
      $('.notice-out-of-stock').hide();
      $('.in-stock').hide();
      $('.shopify-payment-button__button').hide();
      $('.btn-product-add-to-cart span').html('Sold Out');
    } else {
      $('.variant-doesnt-exist').html('');
      // if inventory for this variant is zero disable the buy button
      if(varinv == 0){
        $('.btn-product-add-to-cart').attr('disabled', 'true');
        $('.quantity__button').attr('disabled', 'true');
        $('.notice-out-of-stock').show();
        $('.in-stock').hide();
        $('.shopify-payment-button__button').hide();
        $('.btn-product-add-to-cart span').html('Sold Out');
      } else {
        $('.btn-product-add-to-cart').removeAttr('disabled');
        $('.quantity__button').removeAttr('disabled', 'true');
        $('.notice-out-of-stock').hide();
        $('.in-stock').show();
        $('.shopify-payment-button__button').show();
        $('.btn-product-add-to-cart span').html('Buy Now');
        if(varinv <= 13){
          $('.in-stock').html('Only <span class="num">' + varinv + '</span> in stock');
        } else {
          $('.in-stock').html('');
        }
      }
    }
    $('.variant-inventory').html(varinv);
  });

  // QUANTITY
  $('.quantity__button').on('click', function(){
    var currentValue = parseInt(document.getElementById("quantity").value);
    if($(this).hasClass('product-minus')){
      if(currentValue != 1){
        var newVal = currentValue - 1;
        $('#quantity').val(newVal);
      }
    } else {
      var newVal = currentValue + 1;
      $('#quantity').val(newVal);
    }
  });

 
});



